// extracted by mini-css-extract-plugin
export var errorIcon = "_kp-1";
export var nameLogo = "_kp-0";